import AvatarInput from '@components/avatar/AvatarInput';

import styled from '@emotion/styled';
import {DialogActions, DialogTitle, Grid, IconButton, Typography} from '@mui/material';

export const DashboardWrapperGrid = styled(Grid)`
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

export const DialogActionsButtonStyle = styled(DialogActions)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
`;

export const ColorPickerMainDiv = styled('div')`
zIndex: 2,
position: relative;
`;

export const IconButtonDiv = styled(IconButton)`
  background-color: #18648a;
  color: #fff;
  border-radius: 20;
  &:hover {
    background-color: #73b7df;
    cursor: pointer;
  }
`;

export const ColorPickerSubDiv = styled('div')`
  position: absolute;
  left: 14rem;
  cursor: pointer;
`;
export const DialogTitleStyle = styled(DialogTitle)`
  color: black;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const CenterCircularProgress = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 70vh;
`;

export const DashboardLayoutGrid = styled(Grid)`
  // width: 100%;
  // height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const InputDiv = styled('div')`
  width: 25%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 900px) {
    width: 50%;
  }

  @media (max-width: 390px) {
    width: 75%;
  }
`;

export const ProfileDiv = styled('div')`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 75px 0 30px 0;

  @media (max-width: 390px) {
    margin: 50px 0 20px 0;
  }
`;

export const MainDescriptionTypography = styled(Typography)`
  padding: 0 0 10px 0;
  color: #4d4d4d;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  letter-spacing: 0.3rem;

  @media (max-width: 390px) {
    width: 90%;
    padding: 0 2px 10px 2px;
    font-size: 20px;
    text-align: center;
  }
`;

export const DescriptionTypography = styled(Typography)`
  padding: 0 0 10px 0;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-style: italic;
  color: #ff6049;

  @media (max-width: 390px) {
    width: 90%;
    padding: 0 2px 10px 2px;
    font-size: 16px;
    text-align: center;
  }
`;

export const TabGrid = styled(Grid)`
  height: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  margin: 0 auto;
`;

export const TabLayoutGrid = styled(Grid)`
  width: 88%;
  padding-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;

  @media (max-width: 390px) {
    padding-top: 25px;
  }
`;

export const TabSectionGrid = styled(Grid)`
  display: flex;
  align-items: center;
  justify-content: center;
  // align-items: flex-start;
  // justify-content: flex-start;
  flex-direction: row;
  // flex-wrap: wrap;
  margin: 0 auto;
  // padding-left: 20px;

  @media (min-width: 1200px) {
    // padding-left: 20px;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 901px) {
    // padding-left: 40px;
    // padding-left: 160px;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 900px) {
    padding: 0;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 390px) {
    padding-left: 0;
    align-items: center;
    justify-content: center;
  }
`;

export const AvatarInputDiv = styled(AvatarInput)<{color: string}>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 23px;
  background-color: ${({color}) => color};
  font-weight: 600;
  letter-spacing: 1px;
  padding: 1.5rem 1.6rem 1.5rem 1.6rem;
  color: white;
  border-radius: 15px;
`;

export const TabNameTypography = styled(Typography)`
  width: 100%;
  height: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  font-weight: 500;
  color: black;
`;

export const TabContainerGrid = styled(Grid)<{
  color?: string;
  borderColor?: string;
}>`
  width: 240px;
  height: 128px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({borderColor}) => borderColor};
  border-radius: 10px;
  padding: 1rem;
  margin: 0.8rem 1rem;
  cursor: pointer;

  &:hover {
    background-color: ${({color}) => color};
    cursor: pointer;
  }

  &:hover ${AvatarInputDiv} {
    background-color: white;
    color: ${({color}) => color};
    cursor: pointer;
  }

  &:hover ${TabNameTypography} {
    color: white;
    cursor: pointer;
  }
`;

export const IconDiv = styled('div')`
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UserNameTypography = styled(Typography)`
  padding: 10px 0 10px 0;
  color: #4d4d4d;
  font-weight: 500;
`;
